exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "span.title  {\n  font-size: small;\n  font-style: italic;\n}\n\ndiv.dbr {\n  border-bottom: thin solid silver;\n  padding-bottom: 0.6ex;\n  margin-bottom: 0.6ex;\n}\n\ndiv.origin {\n  background:#abc;\n}\n\ndiv.collapseButton {\n  padding:1ex;\n  text-align: center;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/patent-family/patent-family.component.css
// module id = 394
// module chunks = 0